import React from 'react';
import styled from 'styled-components';

import RetentionTableResult from '../../retention/RetentionTableResult';
import Chart from '../../../chart/complexRetention/Chart';
import { retentionCharts, retentionViews } from '../../../constants/retention';

const StyledRetentionWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`;

const RetentionSimplePreview = (props) => {
  const { options } = props;
  return (
    <StyledRetentionWrapper>
      {options.view === retentionViews.TABLE && <RetentionTableResult {...props} />}
      {retentionCharts.includes(options.view) && <Chart {...props} height="100%" fromDashboard />}
    </StyledRetentionWrapper>
  );
};

export default RetentionSimplePreview;
